<template lang="pug">
  #membership.admin.theme-1
    section.material-half-bg
      .cover
    section.membership-form
      .modal(tabindex="-1" style="position: relative; display: block;", v-if="state.matches('initializing.working')")
        .modal-dialog.modal-sm.modal-dialog-centered
          .modal-content
            .modal-body
              .d-flex.align-items-center
                .spinner-border
                span &nbsp;Initializing. . .
      .modal(tabindex="-1" style="position: relative; display: block;", v-if="state.matches('initializing.failure')")
        .modal-dialog.modal-dialog-centered
          .modal-content
            .modal-header
              h1.modal-title.text-center
                i.fa.fa-exclamation-circle.text-danger
                |&nbsp;Oops!
            .modal-body
              p There was an error while initializing form for membership. Please click <a href="javascript:void(0)" @click.prevent="send('WORKING');">here</a> to try again.
      div(v-else-if="!state.matches('initializing')")
        .dropdown(style="position: fixed; z-index: 9999; bottom: 0; right: 0;")
          button.btn.btn-sm.btn-dark.dropdown-toggle(type="button" v-if="isDev" data-toggle="dropdown")
            i.fa.fa-cog
          .dropdown-menu(style="z-index: 9999;")
            a.dropdown-item(href="javascript:void(0)" @click.prevent="testData()") Generate data
        .modal(tabindex="-1" style="position: relative; display: block;")
          .modal-dialog.modal-lg
            .modal-content
              .modal-header.d-flex.justify-content-center
                div
                  span.cursor-pointer.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 0, 'badge-primary': state.matches('welcome')}") Welcome
                  span.cursor-pointer.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 0, 'badge-primary': state.matches('video')}") Seminar Video
                  span.cursor-pointer.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 1, 'badge-primary': state.matches('step_1')}") Select Membership
                  span.cursor-pointer.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 2, 'badge-primary': state.matches('step_2')}") Member Info
                  span.cursor-pointer.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 3, 'badge-primary': state.matches('step_3')}") Other Info
                  span.cursor-pointer.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 4, 'badge-primary': state.matches('step_4')}") Identification
                  span.cursor-pointer.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 5, 'badge-primary': state.matches('step_5')}") Beneficiary Info
                  span.cursor-pointer.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 6, 'badge-primary': state.matches('branch')}") Branch
                  span.cursor-pointer.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 7, 'badge-primary': state.matches('attachment')}") Attachment
                  span.cursor-pointer.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 8, 'badge-primary': state.matches('confirmatory')}") Confirmation
                //- .btn-group.btn-sm
                  button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 1, 'btn-primary': state.matches('step_1')}") Step 1
                  button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 2, 'btn-primary': state.matches('step_2')}") Step 2
                  button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 3, 'btn-primary': state.matches('step_3')}") Step 3
                  button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 4, 'btn-primary': state.matches('step_4')}") Step 4
                  button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 5, 'btn-primary': state.matches('step_5')}") Step 5
                  button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 6, 'btn-primary': state.matches('step_6')}") Step 6
                  button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 7, 'btn-primary': state.matches('step_7')}") Step 7
              .modal-body
                .row
                  .col-12(v-show="state.matches('welcome')")
                    Welcome(
                      :memberships="state.context.memberships"
                    )
                  .col-12(v-show="state.matches('video')")
                    Video(@ended="send('VIDEO_ENDED')")
                  .col-12(v-show="state.matches('step_1')")
                    SelectMembership(ref="Step1Cmpt"
                      v-model="personalDetailField.membership"
                      :memberships="state.context.memberships"
                      @next="send('NEXT')")
                  .col-12(v-show="state.matches('step_2')")
                    MemberInfo(ref="Step2Cmpt"
                      v-model="personalDetailField"
                      :coops="state.context.coops",
                      :memberships="state.context.memberships"
                      @prev="send('PREV')", @next="send('NEXT')")
                  .col-12(v-show="state.matches('step_3')")
                    OtherInfo(ref="Step3Cmpt"
                      v-model="extendedInfoField"
                      @prev="send('PREV')", @next="send('NEXT')")
                  .col-12(v-show="state.matches('step_4')")
                    step_4(ref="Step4Cmpt"
                      v-model="identificationInfo"
                      @prev="send('PREV')",
                      @next="send('NEXT')")
                  .col-12(v-show="state.matches('step_5')")
                    step_5(ref="Step5Cmpt"
                      v-model="beneficiariesField"
                      @prev="send('PREV')"
                      @next="send('NEXT')")
                  .col-12(v-show="state.matches('branch')")
                    Branch(ref="Step7Cmpt"
                      :coops="state.context.coops"
                      v-model="preferredBranch"
                      @onSelectBranch="handleSelectBranch"
                      @prev="send('PREV')"
                      @next="send('NEXT')"
                    )
                    
                  .col-12(v-show="state.matches('confirmatory')")
                    Confirmatory(ref="Step6Cmpt"
                      v-model="confirmatoryField"
                      @prev="send('PREV')"
                      @next="send('NEXT')"
                    )
                  .col-12(v-show="state.matches('attachment')")
                    Attachment(ref="AttachmentCmpt"
                      v-model="attachmentField"
                      :errors="state.context.errors.attachment"
                      :requirements="membershipRequirements"
                      :paymentMethods="((selectedBranch || {}).payment_methods || []).filter(o => o.is_active)"
                      @prev="send('PREV')"
                      @next="send('NEXT')"
                    )
                  .col-12(v-show="state.matches('submit')")
                    Submit(
                      :processing="state.matches('submit.process')"
                      :failed="state.matches('submit.failure')"
                      :success="state.matches('submit.success')"
                      @retry="send('SUBMIT')"
                      @navToLogin="navigateToLogin()"
                      @backToForm="backToForm()"
                    )
                  //- .col-12(v-show="state.matches('step_6')")
                    step_6
                  //- .col-12(v-show="state.matches('step_7')")
                    step_7
              .modal-footer.d-flex.justify-content-between
                span(v-if="['welcome', 'video', 'submit'].some(state.matches)") &nbsp;
                button.btn.btn-secondary(v-else="" type="button" @click.prevent="send('PREV')") Previous
                
                button.btn.btn-primary(type="button", v-if="['step_1', 'step_2', 'step_3', 'step_4', 'step_5', 'attachment', 'branch'].some(state.matches)" @click.prevent="send('NEXT')") Next
                button.btn.btn-primary(type="button", v-if="state.matches('confirmatory')" @click.prevent="send('SUBMIT')") SUBMIT
                
                button.btn.btn-primary(type="button" v-if="state.matches('welcome')" @click.prevent="send('PROCEED_TO_VIDEO')") Proceed
                button.btn.btn-primary(type="button" v-if="state.matches('video.end')" @click.prevent="send('PROCEED_TO_PRICES')") Proceed
</template>

<style scoped="">
.cursor-pointer {
  cursor: pointer;
}
</style>
<script>
import faker from 'faker';
import { ref, reactive, onMounted, watch } from '@vue/composition-api';
import { createMachine, assign } from 'xstate';
import { useMachine } from 'xstate-vue2';
import moment from 'moment';
const Machine = createMachine(require('./index.state').default);

export default {
  name: 'membership',
  components: {
    Welcome: require('./components/welcome.vue').default,
    Video: require('./components/video.vue').default,
    SelectMembership: require('./components/select-membership.vue').default,
    MemberInfo: require('./components/member-info.vue').default,
    OtherInfo: require('./components/other-info.vue').default,
    step_4: require('./components/step_4.vue').default,
    step_5: require('./components/step_5.vue').default,
    Confirmatory: require('./components/confirmatory.vue').default,
    Branch: require('./components/branch.vue').default,
    Attachment: require('./components/attachment.vue').default,
    Submit: require('./components/submit.vue').default,
  },

  setup(props, { root }) {
    // console.log(global.Yup);
    const isDev = ref(process.env.NODE_ENV === 'development');
    const selectedBranch = ref({});
    const Step1Cmpt = ref(null);
    const Step2Cmpt = ref(null);
    const Step3Cmpt = ref(null);
    const Step4Cmpt = ref(null);
    const Step5Cmpt = ref(null);
    const Step6Cmpt = ref(null);
    const Step7Cmpt = ref(null);
    const AttachmentCmpt = ref(null);
    const membershipRequirements = ref([]);
    // const consentField = reactive({
    //   picture: null,
    //   validId: null,
    //   picWithId: null,
    //   readsConsent: false,
    //   authorized: false,
    // })
    const confirmatoryField = reactive({
      understand: false,
      confirm: false,
    });
    const attachmentField = reactive({
      requirements: [],
      paymentMethod: '',
      proofOfPayment: [],
    });
    const preferredBranch = ref(null);
    const extendedInfoField = reactive({
      spouceFirstName: '',
      spouceMiddleName: '',
      spouceLastName: '',
      spouceDateEmployed: '',
      spouceEmployment: '',
      spoucePosition: '',
      motherFirstName: '',
      motherMiddleName: '',
      motherLastName: '',
      motherSuffix: '',
      fatherFirstName: '',
      fatherMiddleName: '',
      fatherLastName: '',
      fatherSuffix: '',
    });
    const identificationInfo = reactive({
      taxIdentificationNumber: '',
      socialSecurityNumber: '',
      HDMF: '',
      PHIC: '',
      cellNumGlobe: '',
      cellNumSmart: '',
      telephoneNumber: '',
      emailAddress: '',
    });
    const beneficiariesField = reactive([]);
    // const agreedToTermsField = ref(false)
    // const emergencyContactField = reactive({
    //   contactPerson: '',
    //   contactNumber: '',
    //   beneficiary1: '',
    //   beneficiary2: '',
    //   beneficiary3: ''
    // })
    let personalDetailField = reactive({
      beneficiary: [],
      membership: '',
      lastName: '',
      firstName: '',
      middleName: '',
      civilStatus: '',
      dateOfBirth: '',
      placeOfBirth: '',
      educationalAttainment: '',
      religion: '',
      nationality: '',
      cid: '',
      title: '',
      alias: '',
      countryOfBirth: '',
      resident: '',
      employer: '',
      dateOfMembership: moment().format('YYYY-MM-DD'),
      lastUpdate: '',
      previousLastName: '',
      suffix: '',
      gender: '',
      employment: '',
      employerAddress: '',
    });
    const { $swal, $store, _router } = root;
    const { send, state } = useMachine(Machine, {
      guards: {},
      actions: {
        setErrorAttachment: assign({
          errors(ctx, event) {
            return {
              ...ctx.errors,
              attachment: event.data,
            };
          },
        }),
        /**
         * [success description]
         * @param  {[type]} ctx   [description]
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        // success(ctx, event) {
        success() {
          // $swal({
          //   icon: 'success',
          //   title: 'Success!',
          //   text: 'Your membership was successfully sent. Please wait up to 3 to 5 days and be notified',
          //   allowOutsideClick: false,
          //   allowEscapeKey: false,
          // }).then((result) => {
          //   _router.replace({ name: 'login' });
          // });
        },
        /**
         * [failure description]
         * @param  {[type]} ctx   [description]
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        // failure(ctx, event) {
        failure() {
          // console.log('event', event);
          // if (event.data.status == 400) {
          //   $swal({
          //     icon: 'error',
          //     title: 'Oops!',
          //     text: event.data.data.message,
          //     allowOutsideClick: false,
          //   });
          // } else {
          //   $swal({
          //     icon: 'error',
          //     title: 'Oops!',
          //     text: "Something wen't wrong. Please try again later.",
          //     allowOutsideClick: false,
          //   });
          // }
        },
        /**
         * [validationError description]
         * @param  {[type]} ctx   [description]
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        // validationError(ctx, event) {
        validationError() {
          $swal({
            icon: 'error',
            title: 'Validation Error!',
            text: 'Please complete the form fields.',
            allowOutsideClick: false,
          });
        },
      },
      services: {
        /**
         * [fetching description]
         * @param  {[type]} ctx   [description]
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        // fetching(ctx, event) {
        fetching() {
          return Promise.all([
            $store.dispatch('coop/getCoops'),
            $store.dispatch('membership/get_types'),
          ]);
        },
        /**
         * [validateStep1 description]
         * @param  {[type]} ctx   [description]
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        // validateStep1(ctx, event) {
        validateStep1() {
          return Step1Cmpt.value.validate();
          // return Promise.resolve(true)
        },
        /**
         * [validateStep2 description]
         * @param  {[type]} ctx   [description]
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        // validateStep2(ctx, event) {
        validateStep2() {
          return Step2Cmpt.value.validate();
        },
        /**
         * [validateStep3 description]
         * @param  {[type]} ctx   [description]
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        // validateStep3(ctx, event) {
        validateStep3() {
          return Step3Cmpt.value.validate();
          // return Promise.resolve(true)
        },
        /**
         * [validateStep4 description]
         * @param  {[type]} ctx   [description]
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        // validateStep4(ctx, event) {
        validateStep4() {
          return Step4Cmpt.value.validate();
        },
        /**
         * [validateStep5 description]
         * @param  {[type]} ctx   [description]
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        // validateStep5(ctx, event) {
        validateStep5() {
          return Step5Cmpt.value.validate();
        },
        /**
         * [validateStep6 description]
         * @param  {[type]} ctx   [description]
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        // validateStep6(ctx, event) {
        validateStep6() {
          // console.log('validateStep6')
          return Step6Cmpt.value.validate();
        },
        /**
         * [validateStep7 description]
         * @param  {[type]} ctx   [description]
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        // validateStep7(ctx, event) {
        validateStep7() {
          return Step7Cmpt.value.validate();
        },
        /**
         * [validateAttachment description]
         * @param  {[type]} ctx   [description]
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        // validateAttachment(ctx, event) {
        validateAttachment() {
          // console.log('validateAttachment', attachmentField);
          const schema = global.Yup.object({
            requirements: global.Yup.array().of(
              global.Yup.object({
                id: global.Yup.number().required(),
                files: global.Yup.array().when('docs', {
                  is: (value) => {
                    return value > 0;
                  },
                  then: (schema) => schema.min(1),
                  otherwise: (schema) => schema.min(0),
                }),
              })
            ),
            paymentMethod: global.Yup.string().required('The payment method field is required.'),
            // .matches(/(BDO Unibank|BDO Network Bank|Landbank)/, {
            //   excludeEmptyString: true,
            //   message: 'The payment method field is invalid.',
            // }),
            proofOfPayment: global.Yup.array().min(1),
          });
          return schema
            .validate(attachmentField, { abortEarly: false })
            .then((data) => {
              return Promise.resolve(data);
            })
            .catch((error) => {
              return Promise.reject(
                error.inner.reduce((acc, curr) => {
                  acc[curr.path] = curr.errors;
                  return acc;
                }, {})
              );
            });
        },
        /**
         * [submitting description]
         * @param  {[type]} ctx   [description]
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        // submitting(ctx, event) {
        submitting() {
          // $swal({
          //   text: 'Your request is currenty on process, please wait. . .',
          //   allowOutsideClick: false,
          //   allowEscapeKey: false,
          // });
          // $swal.showLoading();
          const payload = new FormData();
          payload.append('branch', preferredBranch.value);
          payload.append('understand_terms', confirmatoryField.understand);
          payload.append('read_terms', confirmatoryField.confirm);
          Object.keys(personalDetailField).forEach((key) => {
            if (key == 'beneficiary') {
              personalDetailField[key].forEach((value, i) => {
                payload.append('information[' + key + '][' + i + ']', personalDetailField[key][i]);
              });
            } else {
              payload.append('information[' + key + ']', personalDetailField[key]);
            }
          });
          Object.keys(extendedInfoField).forEach((key) => {
            payload.append('extendedInformation[' + key + ']', extendedInfoField[key]);
          });
          Object.keys(identificationInfo).forEach((key) => {
            payload.append('identification[' + key + ']', identificationInfo[key]);
          });

          beneficiariesField.forEach((item, index) => {
            Object.keys(item).forEach((key) => {
              payload.append(
                'beneficiary[' + index + '][' + key + ']',
                beneficiariesField[index][key]
              );
            });
          });
          attachmentField.requirements.forEach((item, index) => {
            payload.append('requirements[' + index + '][id]', item.id);
            item.files.forEach((file, fileIndex) => {
              payload.append('requirements[' + index + '][files][' + fileIndex + ']', file);
            });
          });
          attachmentField.proofOfPayment.forEach((item, index) => {
            payload.append('proofOfPayment[' + index + ']', item);
          });
          payload.append('paymentMethod', attachmentField.paymentMethod);
          return $store.dispatch('membership/applyMagrow', payload);
        },
      },
    });
    // watch(personalDetailField, (currentVal, oldVal) => {
    watch(personalDetailField, (currentVal) => {
      // console.log(currentVal.membership, oldVal.membership)
      if (currentVal.membership) {
        const membership = state.value.context.memberships.find(
          (o) => o.id == currentVal.membership
        );
        const _reqs = (membership || {}).documentaries || [];
        membershipRequirements.value = _reqs;
      } else {
        membershipRequirements.value = [];
      }
    });
    onMounted(() => {});

    const testData = () => {
      // console.log('Generate test data.');
      const coop = faker.random.arrayElement(state.value.context.coops);
      preferredBranch.value = coop.id;
      handleSelectBranch(coop);
      confirmatoryField.understand = true;
      confirmatoryField.confirm = true;
      personalDetailField.beneficiary = [faker.random.arrayElement(['4PS', 'ARB', 'IP', 'NA'])];
      personalDetailField.membership = faker.random.arrayElement(
        state.value.context.memberships
      ).id;
      personalDetailField.lastName = faker.name.lastName();
      personalDetailField.firstName = faker.name.firstName();
      personalDetailField.middleName = faker.name.lastName();
      personalDetailField.civilStatus = faker.random.arrayElement([
        'SINGLE',
        'MARRIED',
        'WIDOWED/WINDOWER',
      ]);
      personalDetailField.dateOfBirth = moment(faker.date.past()).format('YYYY-MM-DD');
      personalDetailField.placeOfBirth = faker.address.streetName();
      personalDetailField.educationalAttainment = faker.random.arrayElement([
        'SCHOOL_LESS_1_YEAR',
        'ELEMENTARY_GRADUATE',
        'HIGH_SCHOOL_GRADUATE',
        'COLLEGE_UNDERGRADUATE',
        'BACHELOR_DEGREE',
        'MATERS_DEGREE',
        'PROFESSIONAL',
      ]);
      personalDetailField.religion = faker.lorem.sentence();
      personalDetailField.nationality = faker.address.country();
      personalDetailField.cid = faker.datatype.number({ min: 10000, max: 99999 });
      personalDetailField.title = faker.name.title();
      personalDetailField.alias = faker.internet.userName();
      personalDetailField.countryOfBirth = faker.address.country();
      personalDetailField.resident = faker.address.streetName();
      personalDetailField.employer = faker.name.firstName() + ' ' + faker.name.lastName();
      personalDetailField.dateOfMembership = moment(faker.date.past()).format('YYYY-MM-DD');
      // personalDetailField.lastUpdate = moment(faker.date.past()).format('YYYY-MM-DD');
      personalDetailField.previousLastName = faker.name.lastName();
      personalDetailField.suffix = faker.name.firstName();
      personalDetailField.gender = faker.random.arrayElement(['MALE', 'FEMALE', 'OTHER']);
      personalDetailField.employment = faker.company.catchPhrase();
      personalDetailField.employerAddress = faker.address.streetName();

      extendedInfoField.spouceFirstName = faker.name.firstName();
      extendedInfoField.spouceMiddleName = faker.name.lastName();
      extendedInfoField.spouceLastName = faker.name.lastName();
      extendedInfoField.spouceDateEmployed = moment(faker.date.past()).format('YYYY-MM-DD');
      extendedInfoField.spouceEmployment = faker.name.jobArea();
      extendedInfoField.spoucePosition = faker.name.jobType();
      extendedInfoField.motherFirstName = faker.name.firstName();
      extendedInfoField.motherMiddleName = faker.name.lastName();
      extendedInfoField.motherLastName = faker.name.lastName();
      extendedInfoField.motherSuffix = faker.name.suffix();
      extendedInfoField.fatherFirstName = faker.name.firstName();
      extendedInfoField.fatherMiddleName = faker.name.lastName();
      extendedInfoField.fatherLastName = faker.name.lastName();
      extendedInfoField.fatherSuffix = faker.name.suffix();

      identificationInfo.taxIdentificationNumber = faker.datatype.number({
        min: 10000,
        max: 99999,
      });
      identificationInfo.socialSecurityNumber = faker.datatype.number({ min: 10000, max: 99999 });
      identificationInfo.HDMF = faker.datatype.number({ min: 10000, max: 99999 });
      identificationInfo.PHIC = faker.datatype.number({ min: 10000, max: 99999 });
      identificationInfo.cellNumGlobe = faker.datatype.number({ min: 1000000, max: 9999999 });
      identificationInfo.cellNumSmart = faker.datatype.number({ min: 1000000, max: 9999999 });
      identificationInfo.telephoneNumber = faker.datatype.number({ min: 1000000, max: 9999999 });
      identificationInfo.emailAddress = faker.internet.email();

      for (let i = 0; i < 2; i++) {
        beneficiariesField.push({
          benificiaryAddress: faker.address.streetName(),
          benificiaryDateOfBirth: moment(faker.date.past()).format('YYYY-MM-DD'),
          benificiaryIDNumber: faker.datatype.number({ min: 1000000, max: 9999999 }),
          benificiaryIDType: faker.random.arrayElement(['SSS', 'UMID', 'Company']),
          benificiaryIssueDate: moment(faker.date.past()).format('YYYY-MM-DD'),
          benificiaryName: faker.name.firstName() + ' ' + faker.name.lastName(),
          benificiaryRelationship: faker.name.jobDescriptor(),
        });
      }
    };

    const navigateToLogin = () => {
      _router.replace({ name: 'login' });
    };
    const backToForm = () => {
      send('BACK_TO_FORM');
    };
    const handleSelectBranch = (branch) => {
      selectedBranch.value = branch;
      // Object.assign(selectedBranch, branch)
      console.info(branch);
    };

    return {
      isDev,
      selectedBranch,
      membershipRequirements,

      extendedInfoField,
      confirmatoryField,
      personalDetailField,
      identificationInfo,
      beneficiariesField,
      preferredBranch,
      attachmentField,

      send,
      state,

      Step1Cmpt,
      Step2Cmpt,
      Step3Cmpt,
      Step4Cmpt,
      Step5Cmpt,
      Step6Cmpt,
      Step7Cmpt,
      AttachmentCmpt,

      testData,

      navigateToLogin,
      backToForm,
      handleSelectBranch,
    };
  },
};
</script>

<style lang="css" scoped></style>
